import WithZoom from './component'

export default WithZoom
